const ISO_COUNTRIES = `Afghanistan|AF;Albania|AL;Algeria|DZ;American Samoa|AS;Andorra|AD;Angola|AO;Anguilla|AI;Antarctica|AQ;Antigua and Barbuda|AG;Argentina|AR;Armenia|AM;Aruba|AW;Australia|AU;Austria|AT;Azerbaijan|AZ;Bahamas|BS;Bahrain|BH;Bangladesh|BD;Barbados|BB;Belarus|BY;Belgium|BE;Belize|BZ;Benin|BJ;Bermuda|BM;Bhutan|BT;Bolivia|BO;Bonaire, Sint Eustatius and Saba|BQ;Bosnia and Herzegovina|BA;Botswana|BW;Bouvet Island|BV;Brazil|BR;British Indian Ocean Territory|IO;Brunei|BN;Bulgaria|BG;Burkina Faso|BF;Burundi|BI;Cabo Verde|CV;Cambodia|KH;Cameroon|CM;Canada|CA;Cayman Islands|KY;Central African Republic|CF;Chad|TD;Chile|CL;China|CN;Christmas Island|CX;Cocos Islands|CC;Colombia|CO;Comoros|KM;Congo|CG;Democratic Republic of the Congo|CD;Cook Islands|CK;Costa Rica|CR;Côte d'Ivoire|CI;Croatia|HR;Cuba|CU;Curaçao|CW;Cyprus|CY;Czechia|CZ;Denmark|DK;Djibouti|DJ;Dominica|DM;Dominican Republic|DO;Ecuador|EC;Egypt|EG;El Salvador|SV;Equatorial Guinea|GQ;Eritrea|ER;Estonia|EE;Eswatini|SZ;Ethiopia|ET;Falkland Islands|FK;Faroe Islands|FO;Fiji|FJ;Finland|FI;France|FR;French Guiana|GF;French Polynesia|PF;French Southern Territories|TF;Gabon|GA;Gambia|GM;Georgia|GE;Germany|DE;Ghana|GH;Gibraltar|GI;Greece|GR;Greenland|GL;Grenada|GD;Guadeloupe|GP;Guam|GU;Guatemala|GT;Guernsey|GG;Guinea|GN;Guinea-Bissau|GW;Guyana|GY;Haiti|HT;Heard Island and McDonald Islands|HM;Holy See|VA;Honduras|HN;Hong Kong|HK;Hungary|HU;Iceland|IS;India|IN;Indonesia|ID;Iran|IR;Iraq|IQ;Ireland|IE;Isle of Man|IM;Israel|IL;Italy|IT;Jamaica|JM;Japan|JP;Jersey|JE;Jordan|JO;Kazakhstan|KZ;Kenya|KE;Kiribati|KI;North Korea|KP;South Korea|KR;Kuwait|KW;Kyrgyzstan|KG;Laos|LA;Latvia|LV;Lebanon|LB;Lesotho|LS;Liberia|LR;Libya|LY;Liechtenstein|LI;Lithuania|LT;Luxembourg|LU;Macao|MO;Madagascar|MG;Malawi|MW;Malaysia|MY;Maldives|MV;Mali|ML;Malta|MT;Marshall Islands|MH;Martinique|MQ;Mauritania|MR;Mauritius|MU;Mayotte|YT;Mexico|MX;Micronesia|FM;Moldova|MD;Monaco|MC;Mongolia|MN;Montenegro|ME;Montserrat|MS;Morocco|MA;Mozambique|MZ;Myanmar|MM;Namibia|NA;Nauru|NR;Nepal|NP;Netherlands|NL;New Caledonia|NC;New Zealand|NZ;Nicaragua|NI;Niger|NE;Nigeria|NG;Niue|NU;Norfolk Island|NF;North Macedonia|MK;Northern Mariana Islands|MP;Norway|NO;Oman|OM;Pakistan|PK;Palau|PW;Palestine|PS;Panama|PA;Papua New Guinea|PG;Paraguay|PY;Peru|PE;Philippines|PH;Pitcairn|PN;Poland|PL;Portugal|PT;Puerto Rico|PR;Qatar|QA;Réunion|RE;Romania|RO;Russia|RU;Rwanda|RW;Saint Barthélemy|BL;Saint Helena|SH;Saint Kitts and Nevis|KN;Saint Lucia|LC;Saint Martin|MF;Saint Pierre and Miquelon|PM;Saint Vincent and the Grenadines|VC;Samoa|WS;San Marino|SM;São Tomé and Príncipe|ST;Saudi Arabia|SA;Senegal|SN;Serbia|RS;Seychelles|SC;Sierra Leone|SL;Singapore|SG;Sint Maarten|SX;Slovakia|SK;Slovenia|SI;Solomon Islands|SB;Somalia|SO;South Africa|ZA;South Georgia and the South Sandwich Islands|GS;South Sudan|SS;Spain|ES;Sri Lanka|LK;Sudan|SD;Suriname|SR;Svalbard and Jan Mayen|SJ;Sweden|SE;Switzerland|CH;Syria|SY;Taiwan|TW;Tajikistan|TJ;Tanzania|TZ;Thailand|TH;Timor-Leste|TL;Togo|TG;Tokelau|TK;Tonga|TO;Trinidad and Tobago|TT;Tunisia|TN;Türkiye|TR;Turkmenistan|TM;Turks and Caicos Islands|TC;Tuvalu|TV;Uganda|UG;Ukraine|UA;United Arab Emirates|AE;United Kingdom|GB;United States|US;United States Minor Outlying Islands|UM;Uruguay|UY;Uzbekistan|UZ;Vanuatu|VU;Venezuela|VE;Vietnam|VN;British Virgin Islands|VG;U.S. Virgin Islands|VI;Wallis and Futuna|WF;Western Sahara|EH;Yemen|YE;Zambia|ZM;Zimbabwe|ZW`;

export const WORLD_COUNTRIES = [
  {
    name: "Somaliland",
    code: "SL",
    pinned: true,
    aliases: ["Republic of Somaliland"],
  },
  ...ISO_COUNTRIES.split(";").map((entry) => {
    const [name, code] = entry.split("|");
    return { name, code, aliases: [] };
  }),
];

export const FEATURED_CITIES = {
  Somaliland: [
    "Hargeisa",
    "Berbera",
    "Borama",
    "Burao",
    "Gabiley",
    "Zeila / Saylac",
    "Erigavo / Ceerigaabo",
    "Las Anod",
    "Sheikh",
    "Baki",
    "Lughaya",
    "Oodweyne",
  ],
  Somalia: [
    "Mogadishu",
    "Kismayo",
    "Baidoa",
    "Bosaso",
    "Galkayo",
    "Beledweyne",
    "Jowhar",
    "Merca / Marka",
    "Garowe",
    "Afgooye",
  ],
  Djibouti: [
    "Djibouti City",
    "Ali Sabieh",
    "Tadjoura",
    "Obock",
    "Dikhil",
    "Arta",
  ],
  Ethiopia: [
    "Addis Ababa",
    "Dire Dawa",
    "Harar",
    "Jijiga",
    "Awbare",
    "Dembel",
    "Chinaksen",
  ],
  Kenya: ["Nairobi", "Mombasa", "Mandera", "Garissa", "Wajir", "Isiolo"],
  "United Kingdom": [
    "London",
    "Birmingham",
    "Manchester",
    "Leicester",
    "Bristol",
    "Cardiff",
    "Glasgow",
  ],
  "United States": [
    "Minneapolis",
    "Columbus",
    "Seattle",
    "Washington, D.C.",
    "New York",
    "Atlanta",
    "Dallas",
  ],
  Canada: ["Toronto", "Ottawa", "Edmonton", "Calgary", "Vancouver"],
  Sweden: ["Stockholm", "Gothenburg", "Malmö", "Uppsala"],
  Norway: ["Oslo", "Bergen", "Stavanger", "Trondheim"],
  Denmark: ["Copenhagen", "Aarhus", "Odense", "Aalborg"],
  Finland: ["Helsinki", "Espoo", "Tampere", "Turku"],
  Netherlands: ["Amsterdam", "Rotterdam", "The Hague", "Utrecht"],
  Germany: ["Berlin", "Frankfurt", "Hamburg", "Munich", "Cologne"],
  "United Arab Emirates": ["Dubai", "Abu Dhabi", "Sharjah", "Ajman"],
  "Saudi Arabia": ["Riyadh", "Jeddah", "Mecca", "Medina", "Dammam"],
  Australia: ["Melbourne", "Sydney", "Perth", "Brisbane", "Adelaide"],
};

export function localeCountrySuggestion() {
  try {
    const locale = new Intl.Locale(navigator.language);
    const region = locale.region;
    return WORLD_COUNTRIES.find((country) => country.code === region) || null;
  } catch {
    return null;
  }
}
